<template>
  <teleport to="body">
    <div
      v-show="show"
      class="fixed left-0 top-0 right-0 bottom-0 px-4 pb-6 sm:p-0 sm:flex sm:items-center sm:justify-center z-50"
    >
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-show="show" class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
      </transition>
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-show="show"
          class="bg-white rounded-lg px-4 pt-5 pb-4 shadow-xl transform transition-all sm:w-full sm:max-w-md sm:p-6 relative z-10"
        >
          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg
              class="h-6 w-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <div class="text-center">
            <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
              Session Expiring Soon
            </h3>
            <p class="text-sm text-gray-500 mb-1">
              You will be logged out due to inactivity in:
            </p>
            <p class="text-3xl font-bold text-gray-800 mb-4 tabular-nums">
              {{ countdown }}
            </p>
            <p class="text-sm text-gray-500 mb-6">
              Move your mouse or press any key to stay logged in, or click the button below.
            </p>
          </div>
          <div class="flex justify-center">
            <button
              type="button"
              class="inline-flex justify-center items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-150"
              @click="stayLoggedIn"
            >
              Stay Logged In
            </button>
          </div>
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script>
const WARNING_SECONDS = 5 * 60;

export default {
  data() {
    return {
      secondsRemaining: WARNING_SECONDS,
      intervalId: null,
    };
  },

  computed: {
    show() {
      return this.$store.state.idle_warning;
    },
    countdown() {
      const m = Math.floor(this.secondsRemaining / 60)
        .toString()
        .padStart(2, "0");
      const s = (this.secondsRemaining % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    },
  },

  watch: {
    show(isShowing) {
      if (isShowing) {
        this.secondsRemaining = WARNING_SECONDS;
        this.intervalId = setInterval(() => {
          if (this.secondsRemaining > 0) {
            this.secondsRemaining--;
          } else {
            clearInterval(this.intervalId);
          }
        }, 1000);
      } else {
        clearInterval(this.intervalId);
        this.secondsRemaining = WARNING_SECONDS;
      }
    },
  },

  beforeUnmount() {
    clearInterval(this.intervalId);
  },

  methods: {
    stayLoggedIn() {
      this.$idleTimer.stayLoggedIn();
    },
  },
};
</script>
